module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-01.e71e7f7f12854f5d4167e9abe800d6e6.png";